import React, { useEffect, useState } from 'react';

import Header from "../components/Header";
import Footer from "../components/Footer";
import Notebox from '../components/Notebox';

import './../theme/ui/alignment.scss';
import './../theme/comp/services.scss';
import './../theme/ui/text.scss';
import BookTwoPopover from '../popovers/Book-two.popover';

interface Subitem {
    type: string;
    price: string;
    description: string;
}

interface ServiceCategory {
    heading: string;
    showcase: number;
    subitems: Subitem[];
}

type ServicesData = ServiceCategory[];


const Services: React.FC = () => {

    const note: string = "24-hour notice required for cancellations; appointments held for 10 minutes, after which you'll need to wait for the next available slot."
    const lastUpdate: string = "Last updated on November 16, 2024. Price may change without notice or may actually vary."

    const [services, setServices] = useState<ServicesData>([]);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        fetch('/price-list.json')
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => setServices(data))
            .catch(error => {
                console.error('Error fetching the services data:', error);
                setError(error.message);
            });
    }, []);

    const bookingLink: string = 'https://trendzone.zenoti.com/webstoreNew';
    const handleOpenLink = () => {
        window.open(bookingLink, '_blank');
    };

    return (
        <main>
            <div className="header-gap"></div>
            <Header solidHeader={true} />
            <h1 className='text-center'>Services & Pricing</h1>

            <Notebox text={note} />

            {/* <div className="services-container">
                {error ? (
                    <div className="error-message text-center">{error}</div>
                ) : (
                    services.map((service, index) => (
                        <ServiceCategoryItem key={index} category={service} />
                    ))
                )}
            </div> */}

            <Notebox text={lastUpdate} />

            <div className='price-watch'>
                <button className="btn-std" onClick={() => handleOpenLink()}>
                    <svg xmlns="http://www.w3.org/2000/svg" className="button-icon" viewBox="0 0 512 512"><circle cx="104" cy="152" r="56" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" /><circle cx="104" cy="360" r="56" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" /><path d="M157 175l-11 15 37 15s3.46-6.42 7-10z" fill="none" stroke="currentColor" strokeLinecap="square" strokeMiterlimit="10" strokeWidth="32" /><path d="M154.17 334.43L460 162c-2.5-6.7-28-12-64-4-29.12 6.47-121.16 29.05-159.16 56.05C205.85 236.06 227 272 192 298c-25.61 19-44.43 22.82-44.43 22.82zM344.47 278.24L295 306.67c14.23 6.74 65.54 33.27 117 36.33 14.92.89 30 .39 39-6z" fill="none" stroke="currentColor" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="32" /><circle cx="256" cy="240" r="32" fill="none" stroke="currentColor" strokeMiterlimit="10" strokeWidth="32" /></svg>
                    Click Here for price and Booking.
                </button>
            </div>


            <Footer />
        </main>
    );
}

interface ServiceCategoryItemProps {
    category: ServiceCategory;
}

const ServiceCategoryItem: React.FC<ServiceCategoryItemProps> = ({ category }) => {
    return (
        <div className="service-category">
            <h2 className='text-center'>{category.heading}</h2>
            <div className="service-category-subitems">
                {category.subitems.map((item, index) => (
                    <ServiceItem key={index} item={item} />
                ))}
            </div>
        </div>
    );
}

interface ServiceItemProps {
    item: Subitem;
}

const ServiceItem: React.FC<ServiceItemProps> = ({ item }) => {

    const [popoverOpen, setPopoverOpen] = useState(false);

    const bookingLink: string = 'https://trendzone.zenoti.com/webstoreNew';
    const handleOpenLink = (url: string) => {
        window.open(url, '_blank');
    };

    return (
        <>
            <div className="service-item text-center" onClick={() => handleOpenLink(bookingLink)}>
                <h3 className='text-uppercase'>{item.type}</h3>
                <p>{item.description}</p>
                <h3>{item.price}</h3>
            </div>
            <BookTwoPopover show={popoverOpen} onClose={() => setPopoverOpen(false)} />
        </>
    );
}

export default Services;